export { default } from "./SectionHero";
